/* FFS deploy 20260708e */
(function () {
  window.__ffsHeroSectionRefresh = true;

  function pickVideoUrl(video) {
    var desktop = video.getAttribute('data-src-desktop');
    var mobile = video.getAttribute('data-src-mobile');
    var useDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (desktop || mobile) {
      return useDesktop ? desktop || mobile : mobile || desktop;
    }
    var sources = video.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      var media = sources[i].getAttribute('media');
      if (!media || window.matchMedia(media).matches) {
        return sources[i].getAttribute('src');
      }
    }
    return video.getAttribute('src') || (sources[0] && sources[0].getAttribute('src'));
  }

  function fixHeroVideos() {
    var css = document.getElementById('ffs-hero-video-css');
    if (css) css.remove();

    document.querySelectorAll('video.slideshow__video').forEach(function (video) {
      var slide = video.closest('.slideshow__slide');
      if (!slide || slide.getAttribute('aria-hidden') === 'true') return;

      var next = pickVideoUrl(video);
      if (!next) return;

      var current = video.getAttribute('src') || '';
      if (current !== next) {
        video.querySelectorAll('source').forEach(function (s) {
          s.remove();
        });
        video.setAttribute('src', next);
        video.load();
      }

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;

      var play = video.play();
      if (play && play.then) {
        play
          .then(function () {
            video.classList.add('is-playing', 'is-frame-ready');
          })
          .catch(function () {});
      }
    });
  }

  function boot() {
    fixHeroVideos();
    window.setTimeout(fixHeroVideos, 400);
    window.setTimeout(fixHeroVideos, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', fixHeroVideos);
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelector('.menu-drawer__dismiss')?.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      }
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowCinematic {
  constructor(container) {
    this.container = container;
    this.frames = Array.from(container.querySelectorAll('.slideshow__cinematic-frame'));
    this.duration = parseInt(container.dataset.cinematicDuration, 10) || 2300;
    this.loop = container.dataset.cinematicLoop !== 'false';
    this.index = 0;
    this.timer = null;
    this.running = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  start() {
    if (this.frames.length === 0) return;
    this.stop();
    this.running = true;
    this.container.classList.add('is-js-ready');

    this.frames.forEach((frame, index) => {
      frame.classList.remove('is-exiting', 'is-entering');
      frame.classList.toggle('is-active', index === 0);
      frame.querySelectorAll('video').forEach((video) => {
        video.classList.remove('is-frame-ready', 'is-playing');
      });
    });
    this.index = 0;

    requestAnimationFrame(() => {
      this.frames[0]?.classList.add('is-entering');
      this.playFrameMedia(this.frames[0]);
    });

    if (this.frames.length > 1 && !this.reducedMotion) {
      this.scheduleNext();
    }
  }

  stop() {
    this.running = false;
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    this.frames.forEach((frame) => this.pauseFrameMedia(frame));
    this.container.classList.remove('is-js-ready');
    this.frames.forEach((frame, index) => {
      frame.classList.remove('is-exiting', 'is-entering', 'is-active');
      if (index === 0) frame.classList.add('is-active');
    });
    this.index = 0;
  }

  getFrameDuration(frame) {
    const custom = parseInt(frame?.dataset?.frameDuration, 10);
    if (!Number.isNaN(custom) && custom > 0) return custom;
    return this.duration;
  }

  playFrameMedia(frame) {
    if (!frame) return;
    const video = frame.querySelector('video');
    if (!video) return;
    video.classList.remove('is-frame-ready', 'is-playing');
    video.currentTime = 0;
    if (video.preload === 'none' || video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
      video.load();
    }

    const reveal = () => video.classList.add('is-frame-ready');
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) reveal();
    else video.addEventListener('loadeddata', reveal, { once: true });

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => video.classList.add('is-playing'))
        .catch(() => {});
    }
  }

  pauseFrameMedia(frame) {
    if (!frame) return;
    frame.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.classList.remove('is-frame-ready', 'is-playing');
    });
  }

  resetFrames() {
    this.frames.forEach((frame, index) => {
      frame.classList.remove('is-exiting', 'is-entering');
      frame.classList.toggle('is-active', index === 0);
    });
    this.index = 0;
  }

  activateFrame(index) {
    const frame = this.frames[index];
    if (!frame) return;

    frame.classList.add('is-active');
    requestAnimationFrame(() => {
      frame.classList.add('is-entering');
    });
    this.index = index;
  }

  next() {
    if (!this.loop && this.index >= this.frames.length - 1) return;

    const current = this.frames[this.index];
    const nextIndex = this.loop ? (this.index + 1) % this.frames.length : this.index + 1;
    const next = this.frames[nextIndex];
    if (!next) return;

    this.pauseFrameMedia(current);
    current.classList.remove('is-entering');
    current.classList.add('is-exiting');

    next.classList.add('is-active');
    requestAnimationFrame(() => {
      next.classList.add('is-entering');
      this.playFrameMedia(next);
    });

    window.setTimeout(() => {
      current.classList.remove('is-active', 'is-exiting');
    }, 420);

    this.index = nextIndex;
  }

  scheduleNext() {
    const current = this.frames[this.index];
    this.timer = window.setTimeout(() => {
      if (!this.running) return;
      if (!this.loop && this.index >= this.frames.length - 1) return;
      this.next();
      if (!this.loop && this.index >= this.frames.length - 1) return;
      this.scheduleNext();
    }, this.getFrameDuration(current));
  }
}

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    this.currentPage = 1;
    this.crossfadeMode = this.slider?.classList.contains('ffs-slideshow--crossfade');

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));

    this.setupSlideshowVideos();
    this.setupCinematicSequences();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    this.initCrossfadeClass();
    this.bootActiveSlide();
  }

  initCrossfadeClass() {
    if (!this.slider || !document.body.classList.contains('template-index')) return;
    if (!this.slider.classList.contains('ffs-slideshow--crossfade')) {
      this.slider.classList.add('ffs-slideshow--crossfade');
      this.crossfadeMode = true;
    }
  }

  initPages() {
    if (this.crossfadeMode) {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.sliderItemsToShow = Array.from(this.sliderItems);
      this.sliderItemOffset = this.slider?.clientWidth || 1;
      this.totalPages = this.sliderItemsToShow.length;
      this.slidesPerPage = 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage || 1;
        this.pageTotalElement.textContent = this.totalPages;
      }

      this.bootActiveSlide();
      return;
    }

    super.initPages();
    this.bootActiveSlide();
  }

  getSlideItemOffset() {
    if (this.crossfadeMode) {
      return this.slider?.clientWidth || this.sliderItemOffset || 1;
    }

    if (this.sliderItemOffset > 0) return this.sliderItemOffset;

    const items = this.getSlideshowItems();
    if (items.length >= 2) {
      const measured = items[1].offsetLeft - items[0].offsetLeft;
      if (measured > 0) return measured;
    }

    const firstItem = items[0];
    if (firstItem?.clientWidth > 0) return firstItem.clientWidth;

    return this.slider?.clientWidth || 0;
  }

  getSlideshowItems() {
    return Array.from(this.sliderItems || []);
  }

  getActiveSlideIndex() {
    const items = this.getSlideshowItems();
    if (!items.length) return 0;

    if (this.crossfadeMode) {
      return Math.min(Math.max((this.currentPage || 1) - 1, 0), items.length - 1);
    }

    const offset = this.getSlideItemOffset();
    if (offset > 0) {
      const index = Math.round(this.slider.scrollLeft / offset);
      return Math.min(Math.max(index, 0), items.length - 1);
    }

    return Math.max(0, (this.currentPage || 1) - 1);
  }

  bootActiveSlide() {
    if (!this.slider) return;
    this.currentPage = this.getActiveSlideIndex() + 1;
    this.setSlideVisibility();
    window.requestAnimationFrame(() => this.setSlideVisibility());
    window.setTimeout(() => this.setSlideVisibility(), 150);
    window.setTimeout(() => this.setSlideVisibility(), 400);
  }

  triggerCinematicText(slide) {
    const cinematicText = slide?.querySelector('.slideshow__text--cinematic');
    if (!cinematicText) return;
    cinematicText.classList.remove('is-entering');
    requestAnimationFrame(() => cinematicText.classList.add('is-entering'));
  }

  setupCinematicSequences() {
    this.cinematicSequences = new Map();
    this.querySelectorAll('[data-cinematic-sequence]').forEach((container) => {
      const slide = container.closest('.slideshow__slide');
      if (slide) {
        this.cinematicSequences.set(slide, new SlideshowCinematic(container));
      }
    });
  }

  setupSlideshowVideos() {
    this.querySelectorAll('.slideshow__video[data-trim-start], .slideshow__video[data-trim-end]').forEach((video) => {
      if (video.dataset.trimBound) return;
      video.dataset.trimBound = 'true';

      const trimStart = parseFloat(video.dataset.trimStart || 0);
      const trimEnd = parseFloat(video.dataset.trimEnd || 0);

      const enforceTrim = () => {
        if (!video.duration || Number.isNaN(video.duration)) return;
        const endTime = video.duration - trimEnd;
        if (video.currentTime < trimStart || (trimEnd > 0 && video.currentTime >= endTime)) {
          video.currentTime = trimStart;
        }
      };

      video.addEventListener('loadedmetadata', enforceTrim);
      video.addEventListener('timeupdate', enforceTrim);
    });

    const items = this.getSlideshowItems();
    const activeIndex = this.getActiveSlideIndex();

    this.querySelectorAll('.slideshow__video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      this.resolveSlideVideoSource(video);

      const slide = video.closest('.slideshow__slide');
      const isActive = items.indexOf(slide) === activeIndex;

      if (isActive) {
        video.preload = 'auto';
        if (video.networkState === HTMLMediaElement.NETWORK_EMPTY || video.readyState === 0) {
          video.load();
        }
      } else {
        video.preload = 'none';
      }
    });

    const activeSlide = items[activeIndex];
    const activeVideo = activeSlide?.querySelector('.slideshow__video');
    if (activeVideo) this.playSlideVideo(activeVideo);
  }

  getVideoStartTime(video) {
    const trimStart = parseFloat(video?.dataset?.trimStart || 0);
    return Number.isNaN(trimStart) ? 0 : trimStart;
  }

  armSlideVideoGestureRetry(video) {
    // play() was rejected by autoplay policy; retry on the first real user
    // interaction, which grants activation. One shot per video.
    if (video.dataset.ffsGestureRetry) return;
    video.dataset.ffsGestureRetry = '1';
    const retry = () => {
      ['pointerdown', 'touchend', 'keydown'].forEach((t) => document.removeEventListener(t, retry, true));
      if (video.closest('.slideshow__slide')?.getAttribute('aria-hidden') === 'false' && video.paused) {
        video.play().catch(() => {});
      }
      delete video.dataset.ffsGestureRetry;
    };
    ['pointerdown', 'touchend', 'keydown'].forEach((t) => document.addEventListener(t, retry, true));
  }

  resolveSlideVideoSource(video) {
    if (!video) return false;

    let desktop = video.dataset.srcDesktop;
    let mobile = video.dataset.srcMobile;

    if (!desktop && !mobile) {
      const sources = Array.from(video.querySelectorAll('source'));
      if (sources.length > 1) {
        const useDesktop = window.matchMedia('(min-width: 750px)').matches;
        for (const source of sources) {
          const media = source.getAttribute('media');
          if (!media || window.matchMedia(media).matches) {
            const picked = source.getAttribute('src');
            if (picked) {
              if (useDesktop) desktop = picked;
              else mobile = picked;
              break;
            }
          }
        }
      }
    }

    if (!desktop && !mobile) return false;

    const useDesktop = window.matchMedia('(min-width: 750px)').matches;
    const next = useDesktop ? desktop || mobile : mobile || desktop;
    if (!next) return false;

    const current = video.getAttribute('src') || video.querySelector('source')?.getAttribute('src') || '';
    if (current === next) return false;

    video.querySelectorAll('source').forEach((source) => source.remove());
    video.setAttribute('src', next);
    video.load();
    return true;
  }

  getSlideVideoPosters(video) {
    const media = video?.closest('.slideshow__media--video');
    if (!media) return [];
    return Array.from(media.querySelectorAll('.slideshow__video-poster'));
  }

  showSlideVideoPosters(video) {
    this.getSlideVideoPosters(video).forEach((poster) => {
      poster.style.opacity = '1';
      poster.style.visibility = 'visible';
    });
  }

  hideSlideVideoPosters(video) {
    this.getSlideVideoPosters(video).forEach((poster) => {
      poster.style.opacity = '0';
      poster.style.visibility = 'hidden';
    });
  }

  markSlideVideoVisible(video) {
    const revealFrame = () => {
      video.classList.add('is-frame-ready');
      this.hideSlideVideoPosters(video);
    };
    const revealPlaying = () => {
      video.classList.add('is-playing');
      video.classList.add('is-frame-ready');
      this.hideSlideVideoPosters(video);
    };

    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) revealFrame();
    else video.addEventListener('loadeddata', revealFrame, { once: true });

    if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      revealPlaying();
      return;
    }

    video.addEventListener('playing', revealPlaying, { once: true });

    const onTime = () => {
      if (video.currentTime > 0) {
        revealPlaying();
        video.removeEventListener('timeupdate', onTime);
      }
    };
    video.addEventListener('timeupdate', onTime);
  }

  resetSlideVideo(video) {
    // Crossfade hero: never pause the muted loop. pause() before it starts
    // cancels the browser's pending declarative autoplay, and pausing later
    // forces a JS play() on re-activation that Safari's autoplay policy can
    // reject (Low Power Mode, per-site settings). Hidden slides are stacked
    // behind the active one, so letting the loop run is invisible and cheap.
    if (this.crossfadeMode && video.hasAttribute('autoplay')) return;
    video.classList.remove('is-playing');
    video.classList.remove('is-frame-ready');
    video.pause();
    video.currentTime = 0;
    video.preload = 'none';
    this.showSlideVideoPosters(video);
  }

  playSlideVideo(video) {
    if (!video) return;

    this.resolveSlideVideoSource(video);
    video.preload = 'auto';
    this.showSlideVideoPosters(video);

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    if (!video.paused && video.currentTime > 0 && !video.ended) {
      video.classList.add('is-playing', 'is-frame-ready');
      this.hideSlideVideoPosters(video);
      return;
    }

    this.markSlideVideoVisible(video);

    const start = this.getVideoStartTime(video);

    const beginPlayback = () => {
      if (video.readyState >= HTMLMediaElement.HAVE_METADATA && start > 0) {
        video.currentTime = start;
      }

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            video.classList.add('is-playing', 'is-frame-ready');
            this.hideSlideVideoPosters(video);
          })
          .catch(() => {
            this.showSlideVideoPosters(video);
            this.armSlideVideoGestureRetry(video);
          });
      } else {
        video.classList.add('is-frame-ready');
        this.hideSlideVideoPosters(video);
      }
    };

    const ensureReady = () => {
      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        beginPlayback();
        return;
      }

      const onReady = () => beginPlayback();
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });

      if (video.networkState === HTMLMediaElement.NETWORK_EMPTY || video.readyState === 0) {
        video.load();
      }
    };

    ensureReady();

    [200, 500, 1000, 2000].forEach((delay) => {
      window.setTimeout(() => {
        if (video.paused && video.closest('.slideshow__slide')?.getAttribute('aria-hidden') === 'false') {
          beginPlayback();
        }
      }, delay);
    });
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.autoplayActive = true;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  getSlideDuration(slideIndex) {
    const slide = this.getSlideshowItems()[slideIndex];
    const duration = parseFloat(slide?.dataset?.slideDuration);
    if (!Number.isNaN(duration) && duration > 0) return duration * 1000;
    return this.autoplaySpeed || 5000;
  }

  scheduleAutoplay() {
    if (!this.autoplayActive) return;
    clearTimeout(this.autoplayTimeout);
    this.autoplayTimeout = window.setTimeout(() => {
      if (!this.autoplayActive) return;
      this.autoRotateSlides();
      this.scheduleAutoplay();
    }, this.getSlideDuration(this.currentPage - 1));
  }

  onButtonClick(event) {
    if (this.crossfadeMode) {
      this.wasClicked = true;
      const items = this.getSlideshowItems();
      if (event.currentTarget.name === 'next') {
        this.currentPage = this.currentPage >= items.length ? 1 : this.currentPage + 1;
      } else {
        this.currentPage = this.currentPage <= 1 ? items.length : this.currentPage - 1;
      }
      this.setSlideVisibility();
      this.update();
      return;
    }

    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
      window.requestAnimationFrame(() => this.setSlideVisibility());
      window.setTimeout(() => this.setSlideVisibility(), 100);
      window.setTimeout(() => this.setSlideVisibility(), 350);
    }, this.announcerBarAnimationDelay);
  }

  update() {
    if (this.crossfadeMode) {
      this.sliderItemsToShow = Array.from(this.sliderItems || []);
      this.sliderItemOffset = this.slider?.clientWidth || 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }
    } else {
      const offset = this.getSlideItemOffset();
      if (offset > 0) {
        this.sliderItemOffset = offset;
      }
      super.update();
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

    if (this.autoplayActive) {
      clearTimeout(this.autoplayTimeout);
      this.scheduleAutoplay();
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    clearTimeout(this.autoplayTimeout);
    this.autoplayActive = true;
    this.scheduleAutoplay();
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
    clearTimeout(this.autoplayTimeout);
    this.autoplayActive = false;
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const items = this.getSlideshowItems();

    if (this.crossfadeMode) {
      const nextIndex = this.currentPage >= items.length ? 0 : this.currentPage;
      this.currentPage = nextIndex + 1;
      this.setSlideVisibility();
      this.update();
      return;
    }

    const offset = this.getSlideItemOffset();
    const nextIndex = this.currentPage >= items.length ? 0 : this.currentPage;
    const slideScrollPosition = nextIndex * offset;

    this.currentPage = nextIndex + 1;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    const items = this.getSlideshowItems();
    const activeIndex = this.getActiveSlideIndex();
    this.currentPage = activeIndex + 1;

    items.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      const video = item.querySelector('.slideshow__video');
      const wasInactive = item.getAttribute('aria-hidden') !== 'false';
      if (index === activeIndex) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
        if (video) {
          window.setTimeout(() => this.playSlideVideo(video), wasInactive ? 80 : 0);
        }
        const cinematic = this.cinematicSequences?.get(item);
        if (cinematic && (wasInactive || !cinematic.running)) {
          cinematic.start();
          this.triggerCinematicText(item);
        }
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        if (video) this.resetSlideVideo(video);
        const cinematic = this.cinematicSequences?.get(item);
        if (cinematic) cinematic.stop();
        item.querySelector('.slideshow__text--cinematic')?.classList.remove('is-entering');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();

    if (this.crossfadeMode) {
      this.currentPage = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
      this.setSlideVisibility();
      this.update();
      return;
    }

    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.classList.contains('related-products')) {
      this.loadRecommendations(this.dataset.productId);
      return;
    }
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }

        this.querySelectorAll('img').forEach((img) => {
          img.loading = 'eager';
          img.style.opacity = '1';
        });
        this.classList.add('scroll-trigger--cancel');
        this.classList.remove('scroll-trigger--offscreen');
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
